module.exports = __webpack_public_path__ + "static/media/checkAction.90f819fa.svg";